<template>
  <v-dialog :value="dialogProp.show" absolute max-width="700" persistent>
    <v-card>
      <v-toolbar dark color="primary">
        <v-toolbar-title class="textwithbackground--text">
          {{ $t('Редактирование списка допущенных к торговой секции организаций') }}
        </v-toolbar-title>
      </v-toolbar>
      <v-row v-if="!!generalError || isLoading" class="my-0 py-0 mx-1">
        <v-col cols="12">
          <v-progress-linear :active="isLoading" color="loader" indeterminate />
        </v-col>
        <v-col class="mx-1">
          <general-error v-if="!!generalError" />
        </v-col>
      </v-row>
      <v-card-text class="red--text caption text-justify pt-2 mt-3">
        <organization-selection
            v-model="organizations"
            :label="$t('Допущенные к торговой секции организации')"
            :search-label="$t('Поиск организации')" />
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-btn
            id="cancelBtn"
            v-test="{ btn: 'cancel' }"
            color="primary"
            @click.stop="cancel">
          {{ $t('Отмена') }}
        </v-btn>
        <v-spacer />
        <v-btn
            id="saveBtn"
            v-test="{ btn: 'save' }"
            :disabled="isLoading"
            class="textwithbackground--text"
            color="primary"
            @click.stop="save">
          {{ $t('Сохранить') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import OrganizationSelection from '@/components/reused/ui/OrganizationSelection.vue'
  import GeneralError from '@/components/reused/common/GeneralError.vue'
  import { mapActions, mapState } from 'vuex'
  import { ORGANIZATION_MANAGEMENT, PRODUCT_SECTION_MANAGEMENT } from '@/constants/store.js'

  export default {
    components: {
      OrganizationSelection,
      GeneralError
    },
    props: {
      dialogProp: {
        id: '',
        show: false
      }
    },
    data () {
      return {
        isLoading: false,
        organizations: []
      }
    },
    computed: {
      ...mapState(ORGANIZATION_MANAGEMENT.NAMESPACE, {
        selectedItems: state => (state[ORGANIZATION_MANAGEMENT.STATE.ORGANIZATIONS_BY_PRODUCT_SECTION] || [])
      })
    },
    created () {
      const vm = this
      vm.clearStore().then(() => {
        if (vm.dialogProp.id) {
          vm.getOrganizationsByProductSection()
        }
      })
    },
    beforeDestroy () {
      this.clearStore()
    },
    methods: {
      ...mapActions(ORGANIZATION_MANAGEMENT.NAMESPACE, {
        getOrganizationsByProductSectionAction: ORGANIZATION_MANAGEMENT.ACTIONS.GET_ORGANIZATIONS_BY_PRODUCT_SECTION,
        clearOrganizationsByProductSectionAction: ORGANIZATION_MANAGEMENT.ACTIONS.CLEAR_ORGANIZATIONS_BY_PRODUCT_SECTION
      }),
      ...mapActions(PRODUCT_SECTION_MANAGEMENT.NAMESPACE, {
        editOrganizationsByProductSectionAction: PRODUCT_SECTION_MANAGEMENT.ACTIONS.EDIT_ORGANIZATIONS_BY_PRODUCT_SECTION
      }),
      clearStore: async function () {
        return Promise.all(
          [
            this.clearOrganizationsByProductSectionAction()
          ])
      },
      getOrganizationsByProductSection: async function () {
        try {
          this.isLoading = true
          await this.getOrganizationsByProductSectionAction({
            productSectionId: this.dialogProp.id
          })
          this.isLoading = false
          this.organizations = this.selectedItems.map(o => o.organizationId)
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      },
      save: async function () {
        try {
          this.isLoading = true
          await this.editOrganizationsByProductSectionAction({
            id: this.dialogProp.id,
            organizations: this.organizations
          })
          this.isLoading = false

          this.cancel()
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      },
      cancel: function () {
        this.$emit('close')
      }
    }
  }
</script>
